export default __webpack_public_path__ + "static/media/15_maxime_dubois.d638de42.jpg";